/**
 * Segment event catalog — merchant dashboard.
 * Prefer props over renaming once an event is live.
 */
export const MerchantEvents = {
  // Auth
  LOGIN_SCREEN: "[Auth View] - Login Screen",
  LOGIN_SUCCESS: "[Auth View] - Successfully Logged In",
  LOGIN_SUCCESS_EMAIL_REDIRECT:
    "[Auth View] - Successfully Logged In via Email Redirect",
  LOGIN_FAILED: "[Auth View] - User Login Failed",
  FORGOT_PASSWORD: "[Auth View] - Forgot Password",
  RESET_PASSWORD: "[Auth View] - Reset Password",
  RESET_PASSWORD_SUBMITTED: "[Auth View] - Reset Password Submitted",
  INVITE_USER_SCREEN: "[Auth View] - Invite User Screen",
  ACCOUNT_ONBOARD_SCREEN: "[Auth View] - Account Onboard Screen",
  LOGOUT: "[Auth View] - Logout",

  // Onboarding (Granular)
  ONBOARDING_STARTED: "[Onboarding] - Started",
  ONBOARDING_OPTION_SELECTED: "[Onboarding] - Option Selected",
  ONBOARDING_SKIPPED: "[Onboarding] - Skipped",
  ONBOARDING_FORM_VALIDATION_ERROR: "[Onboarding] - Form Validation Error",
  ONBOARDING_SUBMIT_CLICKED: "[Onboarding] - Submit Clicked",
  ONBOARDING_API_ERROR: "[Onboarding] - API Error",
  ONBOARDING_SUCCESS_SEEN: "[Onboarding] - Success Screen Seen",
  ONBOARDING_COMPLETED: "[Onboarding] - Completed (Dashboard Entered)",

  // Global
  BRANCH_CHANGED: "[Merchant View] - Branch Changed",
  LANGUAGE_SWITCHED: "Language Switched",
  DOWNLOAD_CSV: "[Merchant View] - Download Current Data as CSV",
  DOWNLOAD_XLS: "[Merchant View] - Download Current Data as XLS",

  // Home / settlements
  HOME: "[Merchant View] - Home",
  HOME_ANALYTICS_HELP_CLOSED:
    "[Merchant View] - Home Analytics Help Modal Closed",
  SETTLEMENT_VIEW: "[Merchant View] - Settlement View",
  SEARCH_SETTLEMENTS: "[Merchant View] - Search Settlements",
  FILTER_INVOICES: "[Merchant View] - Filter Invoices",

  // Invoices
  INVOICES_LIST: "[Merchant View] - Invoices List View",
  INVOICE_MODAL_OPEN: "[Merchant View] - Invoice Modal Open",
  SEARCH_INVOICES: "[Merchant View] - Search Invoices",
  INVOICES_BULK_UPDATE: "[Merchant View] - Invoices Bulk Update",
  INVOICE_DETAIL: "[Merchant View] - Invoice Detail",
  INVOICE_CREATE_INITIATED: "[Merchant View] - Invoice Create Initiated",
  INVOICE_CREATED: "[Merchant View] - Invoice Created",
  INVOICE_CREATE_FAILED: "[Merchant View] - Invoice Create Failed",
  OPEN_PAYMENT_REVIEW_MODAL: "[Merchant View] - Open Payment Review Modal",
  OPEN_MARK_AS_PAID_MODAL: "[Merchant View] - Open Mark as paid modal",
  MARK_AS_PAID: "[Merchant View] - Mark as Paid",
  MARK_AS_PAID_FAILED: "[Merchant View] - Failed to mark as paid",
  QURRAH: "[Merchant View] - QURRAH",
  PAYMENT_NOT_RECEIVED: "[Merchant View] - Payment Not Received",
  PAYMENT_NOT_RECEIVED_FAILED:
    "[Merchant View] - Failed the action payment not received",
  GENERATING_PDF: "[Merchant View] - Generating PDF",
  GENERATE_PDF_FAILED: "[Merchant View] - Failed to generate PDF",
  DOWNLOAD_INVOICE: "[Merchant View] - Download Invoice",
  REFUND_PAYMENT: "[Merchant View] - Refund Payment",
  REFUND_SUCCESS: "[Merchant View] - Refund Success",
  REFUND_FAILED: "[Merchant View] - Failed to refund",
  CANCEL_INVOICE: "[Merchant View] - Cancel Invoice",
  CANCEL_INVOICE_SUCCESS: "[Merchant View] - Cancel Invoice Success",
  CANCEL_INVOICE_FAILED: "[Merchant View] - Cancel Invoice Failed",
  RESEND_INVOICE: "[Merchant View] - Resend Invoice",
  SEARCH_PRODUCT: "[Merchant View] - Search Product",

  // Subscriptions
  SUBSCRIPTIONS_LIST: "[Merchant View] - Subscriptions List View",
  SUBSCRIPTION_MODAL_OPEN: "[Merchant View] - Subscription Modal Open",
  SEARCH_SUBSCRIPTIONS: "[Merchant View] - Search Subscriptions",
  FILTER_SUBSCRIPTIONS: "[Merchant View] - Filter Subscriptions",
  SUBSCRIPTION_DETAIL: "[Merchant View] - Subscription Detail",
  SUBSCRIPTION_CREATE_INITIATED:
    "[Merchant View] - Subscription Create Initiated",
  SUBSCRIPTION_CREATED: "[Merchant View] - Subscription Created",
  SUBSCRIPTION_CREATE_FAILED: "[Merchant View] - Subscription Create Failed",
  SUBSCRIPTION_CANCELLED: "[Merchant View] - Subscription Cancelled",

  // Payment links
  PAYMENT_LINKS_LIST: "[Merchant View] - Payment Links List View",
  PAYMENT_LINK_MODAL_OPEN: "[Merchant View] - Payment Link Modal Open",
  PAYMENT_LINK_DETAIL: "[Merchant View] - Payment Link Detail",
  PAYMENT_LINK_CREATE_INITIATED:
    "[Merchant View] - Payment Link Create Initiated",
  PAYMENT_LINK_CREATED: "[Merchant View] - Payment Link Created",
  PAYMENT_LINK_CREATE_FAILED: "[Merchant View] - Payment Link Create Failed",
  PAYMENT_LINK_UPDATED: "[Merchant View] - Payment Link Updated",
  PAYMENT_LINK_DEACTIVATED: "[Merchant View] - Payment Link Deactivated",
  PAYMENT_LINK_COPIED: "[Merchant View] - Payment Link Copied",
  PAYMENT_LINK_QR_OPENED: "[Merchant View] - Payment Link QR Opened",
  SEARCH_PAYMENT_LINKS: "[Merchant View] - Search Payment Links",

  // Products
  PRODUCTS_LIST: "[Merchant View] - Products",
  PRODUCT_DETAIL: "[Merchant View] - Product Detail",
  SEARCH_PRODUCTS: "[Merchant View] - Search Products",
  ADD_PRODUCT_CLICKED: "[Merchant View] - Add Product Clicked",
  ADD_PRICING_TABLE_CLICKED: "[Merchant View] - Add Pricing Table Clicked",
  PRODUCT_CREATE_INITIATED: "[Merchant View] - Product Create Initiated",
  PRODUCT_CREATED: "[Merchant View] - Product Created",
  PRODUCT_UPDATED: "[Merchant View] - Product Updated",
  PRODUCT_DELETED: "[Merchant View] - Product Deleted",

  // Customers
  CUSTOMERS_LIST: "[Merchant View] - Customers",
  CUSTOMER_DETAIL: "[Merchant View] - Customer Detail",
  SEARCH_CUSTOMERS: "[Merchant View] - Search Customers",
  ADD_CUSTOMER_CLICKED: "[Merchant View] - Add Customer Clicked",
  CUSTOMER_CREATE_INITIATED: "[Merchant View] - Customer Create Initiated",
  CUSTOMER_CREATED: "[Merchant View] - Customer Created",
  CUSTOMER_UPDATED: "[Merchant View] - Customer Updated",

  // Coupons
  COUPONS_LIST: "[Merchant View] - Coupons List View",
  SEARCH_COUPONS: "[Merchant View] - Search Coupons",
  COUPON_CREATE_INITIATED: "[Merchant View] - Coupon Create Initiated",
  COUPON_CREATED: "[Merchant View] - Coupon Created",
  COUPON_UPDATED: "[Merchant View] - Coupon Updated",
  COUPON_DELETED: "[Merchant View] - Coupon Deleted",

  // Forms
  FORMS_LIST: "[Merchant View] - Forms List View",
  FORM_DETAIL: "[Merchant View] - Form Detail",
  FORM_CREATE_INITIATED: "[Merchant View] - Form Create Initiated",
  FORM_CREATED: "[Merchant View] - Form Created",
  FORM_UPDATED: "[Merchant View] - Form Updated",
  FORM_PUBLISHED: "[Merchant View] - Form Published",

  // KYB / onboarding
  KYB_STEP_VIEWED: "[Merchant View] - KYB Step Viewed",
  KYB_STEP_SUBMITTED: "[Merchant View] - KYB Step Submitted",
  KYB_COMPLETED: "[Merchant View] - KYB Completed",
  KYB_API_ERROR: "[Merchant View] - KYB API Error",
  KYB_DOCUMENT_UPLOAD_REJECTED:
    "[Merchant View] - KYB Document Upload Rejected",
  KYB_OCR_EXTRACTION_FAILED: "[Merchant View] - KYB OCR Extraction Failed",
  KYB_CONTACT_SALES_CLICKED: "[Merchant View] - KYB Contact Sales Clicked",
  ONBOARDING_STEP_VIEWED: "[Merchant View] - Onboarding Step Viewed",
  COMPLETE_REGISTRATION_VIEW: "[Merchant View] - Complete Registration",

  // Settings
  SETTINGS: "[Merchant View] - Settings",
  SETTINGS_COMPANY_PROFILE: "[Merchant View] - Settings - Company Profile",
  SETTINGS_UPLOAD_LOGO_INITIATED:
    "[Merchant View] - Settings - Company Profile - Upload Logo Initiated",
  SETTINGS_CHANGE_NAME_INITIATED:
    "[Merchant View] - Settings - Company Profile - Change Name Initiated",
  SETTINGS_CHANGE_URL_INITIATED:
    "[Merchant View] - Settings - Company Profile - Change URL Initiated",
  SETTINGS_UPLOAD_LOGO_SUCCESS:
    "[Merchant View] - Settings - Company Profile - Upload Logo Success",
  SETTINGS_UPLOAD_LOGO_FAILED:
    "[Merchant View] - Settings - Company Profile - Upload Logo Failed",
  SETTINGS_USER_PROFILE: "[Merchant View] - Settings - User Profile",
  SETTINGS_UPLOAD_AVATAR_SUCCESS:
    "[Merchant View] - Settings - User Profile - Upload Avatar Success",
  SETTINGS_UPLOAD_AVATAR_FAILED:
    "[Merchant View] - Settings - User Profile - Upload Avatar Failed",
  SETTINGS_CHANGE_PASSWORD:
    "[Merchant View] - Settings - User Profile - Change Password",
  SETTINGS_CHANGE_PASSWORD_FAILED:
    "[Merchant View] - Settings - User Profile - Change Password Failed",
  SETTINGS_USERS: "[Merchant View] - Settings - Users",
  SETTINGS_INVITE_USER_INITIATED:
    "[Merchant View] - Settings - Users - Invite User Initiated",
  SETTINGS_INVITE_USER_SUCCESS:
    "[Merchant View] - Settings - Users - Invite User Success",
  SETTINGS_INVITE_USER_ERROR:
    "[Merchant View] - Settings - Users - Invite User Error",
  SETTINGS_BRANCHES: "[Merchant View] - Settings - Branches",
  SETTINGS_CREATE_BRANCH_INITIATED:
    "[Merchant View] - Settings - Branches - Create Branch Initiated",
  SETTINGS_BRANCHES_SAVE: "[Merchant View] - Settings - Branches - Save",
  SETTINGS_BRANCHES_ERROR: "[Merchant View] - Settings - Branches - Error",
  SETTINGS_BRANCHES_DELETE: "[Merchant View] - Settings - Branches - Delete",
  SETTINGS_BRANCHES_EDIT: "[Merchant View] - Settings - Branches - Edit Branch",
  SETTINGS_BANK_ACCOUNT: "[Merchant View] - Settings - Bank Account",
  SETTINGS_BANK_UPDATED: "[Merchant View] - Settings - Bank Account Updated",
  SETTINGS_BANK_ADDED: "[Merchant View] - Settings - Bank Account Added",
  SETTINGS_BANK_ERROR: "[Merchant View] - Settings - Bank Account Error",
  SETTINGS_PAYMENT_METHODS: "[Merchant View] - Settings - Payment Methods",
  SETTINGS_PAYMENT_METHOD_TOGGLED:
    "[Merchant View] - Settings - Payment Method Toggled",
  SETTINGS_REFUND_POLICY: "[Merchant View] - Settings - Refund Policy",
  SETTINGS_REFUND_POLICY_UPDATED:
    "[Merchant View] - Settings - Refund Policy Updated",
  SETTINGS_CUSTOMER_PORTAL: "[Merchant View] - Settings - Customer Portal",
  SETTINGS_CUSTOMER_PORTAL_SAVED:
    "[Merchant View] - Settings - Customer Portal Saved",
  SETTINGS_API_KEYS: "[Merchant View] - Settings - API Keys",
  SETTINGS_CREATE_API_KEY_INITIATED:
    "[Merchant View] - Settings - Create API KEY Initiated",
  SETTINGS_CREATE_API_KEY: "[Merchant View] - Settings - Create API KEY",
  SETTINGS_CREATE_API_KEY_ERROR:
    "[Merchant View] - Settings - Create API KEY Error",
  SETTINGS_REVOKE_API_KEY: "[Merchant View] - Settings - Revoke API KEY",
  SETTINGS_WEBHOOKS: "[Merchant View] - Settings - Webhooks",
  SETTINGS_CREATE_WEBHOOK_INITIATED:
    "[Merchant View] - Settings - Create Webhook Initiated",
  SETTINGS_CREATE_WEBHOOK: "[Merchant View] - Settings - Create Webhook",
  SETTINGS_CREATE_WEBHOOK_ERROR:
    "[Merchant View] - Settings - Create Webhook Error",
  SETTINGS_DELETE_WEBHOOK: "[Merchant View] - Settings - Delete Webhook",
  WEBHOOK_DELIVERIES_LIST: "[Merchant View] - Webhook Deliveries List",
  WEBHOOK_DELIVERY_DETAIL: "[Merchant View] - Webhook Delivery Detail",
  SETTINGS_ACCOUNTING_INTEGRATIONS:
    "[Merchant View] - Settings - Accounting Integrations",
  SETTINGS_CREATE_ACCOUNTING_INTEGRATION:
    "[Merchant View] - Settings - Create Accounting Integration",
  SETTINGS_CREATE_ACCOUNTING_INTEGRATION_ERROR:
    "[Merchant View] - Settings - Create Accounting Integration Error",

  // Sandbox
  SANDBOX_HOME: "[Merchant View] - Sandbox Home",
} as const;

export type MerchantEventName =
  (typeof MerchantEvents)[keyof typeof MerchantEvents];
